var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2.375-11.094A8.678,8.678,0,0,1,8.031-13a8.678,8.678,0,0,1,5.656,1.906A5.743,5.743,0,0,1,16.031-6.5a5.743,5.743,0,0,1-2.344,4.594A8.678,8.678,0,0,1,8.031,0,9.5,9.5,0,0,1,4.688-.594,6.993,6.993,0,0,1,.281,1,.208.208,0,0,1,.156.953.31.31,0,0,1,.063.844.227.227,0,0,1,.109.578Q.219.469.484.141a8.912,8.912,0,0,0,.7-1.094,6.3,6.3,0,0,0,.625-1.453A5.628,5.628,0,0,1,.031-6.5,5.743,5.743,0,0,1,2.375-11.094Z",
    transform: "translate(-0.031 13)",
    fill: "#2a66bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.14774adec48d7c9eb41770580a30394f.svg";
export { ForwardRef as ReactComponent };